module.exports = __webpack_public_path__ + "media/images/front/treatment_support/setting_add_home_screen/img07-0a7e061c57fab95b5a179f3bfcbb0fc2.png";